import {
  actionTypes,
  PreguntasPredefinidasActions,
  PreguntasPredefinidasState,
  PreguntasPredefinidasStatus,
  initialState,
} from './types'

const IdiomasReducer = (
  state: PreguntasPredefinidasState = initialState,
  action?: PreguntasPredefinidasActions
): PreguntasPredefinidasState => {
  switch (action?.type) {
    case actionTypes.PREGUNTAS_PREDEFINIDAS_FETCH:
      return {
        ...state,
        status: PreguntasPredefinidasStatus.Loading,
      }
    case actionTypes.PREGUNTAS_PREDEFINIDAS_SUCCESS:
      return {
        ...state,
        status: PreguntasPredefinidasStatus.Success,
        preguntasPredefinidas: action?.payload?.preguntasPredefinidas,
      }
    case actionTypes.PREGUNTAS_PREDEFINIDAS_ERROR:
      return {
        ...state,
        status: PreguntasPredefinidasStatus.Error,
      }
    case actionTypes.PREGUNTAS_PREDEFINIDAS_RESET:
      return {
        ...state,
        status: PreguntasPredefinidasStatus.Idle,
      }
    default:
      return state
  }
}

export default IdiomasReducer
